import { AutoMap } from "@automapper/classes";

export class MaterielCompresseur {
    @AutoMap()
    ReferenceHuile!: string;
}